import { create } from 'zustand';
import type { Track } from '@/types';

/**
 * Transient draft for the in-progress recommendation. The search screen (or the
 * Home "Reco" action) sets the picked track; the share screen reads it.
 * `parentRecommendationId` is set when re-recommending from a discover card, so
 * the new reco links to the one that triggered it.
 */
interface RecoDraftState {
  track: Track | null;
  source: 'spotify' | 'deezer';
  parentRecommendationId: number | null;
  setDraft: (track: Track, source: 'spotify' | 'deezer', parentRecommendationId?: number) => void;
  clear: () => void;
}

export const useRecoDraft = create<RecoDraftState>((set) => ({
  track: null,
  source: 'deezer',
  parentRecommendationId: null,
  setDraft: (track, source, parentRecommendationId) =>
    set({ track, source, parentRecommendationId: parentRecommendationId ?? null }),
  clear: () => set({ track: null, parentRecommendationId: null }),
}));
